<template>
    <div class="almoxarifado-dashboard">
        <div class="row">
            <div class="col-md-12 grid-margin">
                <b-card bg-variant="light" data-manual-filter :body-class="filtersOpen ? '' : 'lg-filter-collapsed'">
                    <div class="card-body">
                        <button type="button"
                            class="btn btn-outline-primary lg-filter-toggle w-100 d-flex justify-content-between align-items-center mb-2"
                            @click="toggleFilters">
                            <span class="d-flex align-items-center">
                                <b-icon icon="funnel" font-scale="1.1" class="mr-2"></b-icon>
                                <span>Filtros</span>
                            </span>
                            <b-icon :icon="filtersOpen ? 'chevron-up' : 'chevron-down'" font-scale="1.1"></b-icon>
                        </button>

                        <div class="lg-filter-container" v-show="filtersOpen">
                            <div class="row">
                                <b-col cols="12" md="6">
                                    <LgFinderPageAlmoxarifado class="mb-0" @onselect="setAlmoxarifado" v-model="almoxarifado" />
                                </b-col>
                                <b-col cols="12" md="4">
                                    <lg-form-const-select label="Mês:" class="mb-0" @change="loadDashboard()" v-model="mes" :options="meses" />
                                </b-col>
                                <b-col cols="12" md="2" class="d-flex align-items-end justify-content-end">
                                    <div class="btn-group">
                                        <b-button size="sm" variant="outline-primary" @click="exportToPDF" title="Exportar PDF">
                                            <b-icon icon="file-earmark-pdf" />
                                        </b-button>
                                        <b-button size="sm" variant="outline-success" @click="exportToExcel" title="Exportar Excel">
                                            <b-icon icon="file-earmark-excel" />
                                        </b-button>
                                    </div>
                                </b-col>
                            </div>
                        </div>
                    </div>
                </b-card>

                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-3 col-md-6 mt-md-0 mt-4">
                                <lg-status-card :value="dashboardData.totalItens" label="Total de Itens" variant="primary" icon="collection" />
                            </div>
                            <div class="col-lg-3 col-md-6 mt-md-0 mt-4">
                                <lg-status-card :value="dashboardData.totalEntradaMes || 0" label="Entradas no mês" variant="success" icon="arrow-down-circle" />
                            </div>
                            <div class="col-lg-3 col-md-6 mt-md-0 mt-4">
                                <lg-status-card :value="dashboardData.totalSaidaMes || 0" label="Saídas no mês" variant="warning" icon="arrow-up-circle" />
                            </div>
                            <div class="col-lg-3 col-md-6 mt-md-0 mt-4">
                                <lg-status-card :value="dashboardData.totalPedidosEmAberto || 0" label="Pedidos pendentes" variant="danger" icon="exclamation-circle" />
                            </div>
                            <div class="col-lg-3 col-md-6 mt-md-0 mt-4">
                                <lg-status-card :value="tempoMedioFmt()" label="Tempo médio de encerramento" sublabel="Em horas" variant="info" icon="clock" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-8 grid-margin stretch-card">
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex flex-column flex-lg-row">
                            <p class="mb-2 mb-lg-0"><b>Top 10 itens</b></p>
                            <div class="filter-wrapper ml-lg-auto d-flex">
                                <select class="form-control form-control-local form-control-sm" v-model="mesSelecionado"
                                    @change="loadDashboard">
                                    <option v-for="month in meses" :key="month.value" :value="month.value"><b>{{
                                        month.text
                                            }}</b>
                                    </option>
                                </select>
                            </div>

                        </div>
                        <div class="chart-container mt-4" style="height:520px;">
                            <canvas id="top10ChartAlmoxarifado"></canvas>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4 grid-margin stretch-card">
                <div class="card">
                    <div class="card-body d-flex flex-column">
                        <div class="wrapper">
                            <h4 class="card-title mb-0"><b>Situação dos Itens</b></h4>
                            <p>Distribuição por situação</p>
                            <div class="mb-4" id="situacao-legend-almoxarifado">
                                <div class="chartjs-legend-almoxarifado">
                                    <ul>
                                        <li><span style="background-color:rgba(75, 192, 192, 0.6)"></span>Inventariando
                                        </li>
                                        <li><span style="background-color:rgba(55, 140, 172, 0.6)"></span>Livre</li>

                                        <li><span style="background-color:rgba(182, 122, 62, 0.6)"></span>Visível
                                        </li>
                                        <li><span style="background-color:rgba(150, 100, 72, 0.6)"></span>Invisível
                                        </li>
                                        <li><span style="background-color:rgba(122, 122, 132, 0.6)"></span>Bloqueado
                                        </li>
                                        <li><span style="background-color:rgba(150, 111, 132, 0.6)"></span>Desbloqueado


                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="chart-container my-auto mx-auto" style="height: 260px; width: 100%;">
                            <canvas id="situacaoChartAlmoxarifado"></canvas>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Chart from 'chart.js';
import ResourceService from "@/core/api/ResourceService";
import LgFinderPageAlmoxarifado from "@/components/Finders/LgFinderPageAlmoxarifado.vue";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import LgStatusCard from "@/core/components/Cards/LgStatusCard.vue";

export default {
    components: {

        LgFinderPageAlmoxarifado,
        LgFormConstSelect,
        LgStatusCard

    },
    name: "AlmoxarifadoDashboard",
    data() {
        return {
            dashboardData: {
                totalEntradaMes: 0,
                totalSaidaMes: 0,
                totalPedidosEmAberto: 0,
                totalItens: 0,
                top10ConsumidosMes: [],
                quantidadePorSitucao: {}
            },

            mes: this.getMesAtual(new Date().getFullYear()),
            mesSelecionado: this.getMesAtual(new Date().getFullYear()),
            meses: this.mesesAteAgora(new Date().getFullYear()),

            almoxarifado: {},
            top10ChartAlmoxarifado: null,
            situacaoChartAlmoxarifado: null,
            chartColors: [
                'rgba(75, 192, 192, 0.6)',
                'rgba(255, 99, 132, 0.6)',
                'rgba(255, 206, 86, 0.6)',
                'rgba(54, 162, 235, 0.6)',
                'rgba(153, 102, 255, 0.6)',
                'rgba(255, 159, 64, 0.6)',
                'rgba(199, 199, 199, 0.6)',
                'rgba(83, 102, 255, 0.6)',
                'rgba(40, 159, 64, 0.6)',
                'rgba(210, 199, 199, 0.6)'
            ],
            chartBorderColors: [
                'rgba(75, 192, 192, 1)',
                'rgba(255, 99, 132, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
                'rgba(199, 199, 199, 1)',
                'rgba(83, 102, 255, 1)',
                'rgba(40, 159, 64, 1)',
                'rgba(210, 199, 199, 1)'
            ],
            filtersOpen: true
        };
    },
    beforeMount() {
        this.$service = new ResourceService("/api/almoxarifado-dashboard");

        this.loadDashboard();
    },
    methods: {
        toggleFilters() {
            this.filtersOpen = !this.filtersOpen;
        },
        tempoMedioFmt() {
            const v = this.dashboardData.tempoMedioEncerramentoPedido;
            if (!v && v !== 0) return 0;
            try { return Number(v).toFixed(2); } catch(e) { return 0; }
        },
        getMesAtual(anoAlvo) {


            const hoje = new Date();
            const anoAtual = hoje.getFullYear();

            const mesAtual = hoje.getMonth();

            const limite = anoAlvo === anoAtual ? mesAtual : 11;

            return limite + 1;

        },
        mesesAteAgora(anoAlvo) {
            const hoje = new Date();
            const anoAtual = hoje.getFullYear();
            const mesAtual = hoje.getMonth();

            const limite = anoAlvo === anoAtual ? mesAtual : 11;

            const nomesDosMeses = [
                { value: 1, text: 'Janeiro' }, { value: 2, text: 'Fevereiro' }, { value: 3, text: 'Março' }, { value: 4, text: 'Abril' },
                { value: 5, text: 'Maio' }, { value: 6, text: 'Junho' }, { value: 7, text: 'Julho' }, { value: 8, text: 'Agosto' },
                { value: 9, text: 'Setembro' }, { value: 10, text: 'Outubro' }, { value: 11, text: 'Novembro' }, { value: 12, text: 'Dezembro' }
            ];

            var mesesFiltrados = nomesDosMeses.slice(0, limite + 1);

            return mesesFiltrados
        },

        setAlmoxarifado(item) {
            this.almoxarifado = item;
            this.loadDashboard();
        },
        async loadDashboard() {
            try {

                if (!this.mes)
                    this.mes = this.getMesAtual(new Date().getFullYear());


                var params = { mes: this.mes, mesSelecionado: this.mesSelecionado };



                if (this.almoxarifado && this.almoxarifado.id)
                    params.almoxarifado = this.almoxarifado.id;

                const response = await this.$service.findAll({
                    page: 1,
                    size: 1000,
                    params: params
                });

                this.dashboardData = response.data;

                this.$nextTick(() => {
                    this.initCharts();
                });
            } catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data
                });
            }
        },


        exportToPDF() {
            this.$notify({
                type: 'info',
                message: 'Exportação para PDF será implementada em breve'
            });
        },

        exportToExcel() {
            this.$notify({
                type: 'info',
                message: 'Exportação para Excel será implementada em breve'
            });
        },

        initCharts() {
            this.inittop10ChartAlmoxarifado();
            this.initsituacaoChartAlmoxarifado();
        },


        inittop10ChartAlmoxarifado() {
            const ctx = document.getElementById('top10ChartAlmoxarifado');
            if (!ctx) return;

            if (this.top10ChartAlmoxarifado) {
                this.top10ChartAlmoxarifado.destroy();
            }

            let data = [];
            let labels = [];
            let values = [];
            let title = 'Top 10 itens';

            if (this.dashboardData.top10ConsumidosMes && this.dashboardData.top10ConsumidosMes.length > 0) {
                data = this.dashboardData.top10ConsumidosMes || [];

                labels = data.map(item => item.descricao);
                values = data.map(item => {
                    return item.quantidade
                });

                title = `Itens mais consumidos no mês`;
            }

            this.top10ChartAlmoxarifado = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: labels,
                    datasets: [{
                        label: 'Quantidade',
                        data: values,
                        backgroundColor: this.chartColors.slice(0, data.length),
                        borderColor: this.chartBorderColors.slice(0, data.length),
                        borderWidth: 1
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    title: {
                        display: true,
                        text: title
                    },
                    legend: { display: false },
                    tooltips: {
                        mode: 'nearest',
                        intersect: true,
                        callbacks: {
                            title: (items, data) => {
                                const idx = items[0].index;
                                return data.labels[idx] || '';
                            },
                            label: (item) => `Quantidade: ${item.yLabel}`
                        }
                    },
                    scales: {
                        xAxes: [{
                            ticks: {
                                autoSkip: true,
                                maxRotation: 0,
                                callback: (value) => this.truncateLabel(value)
                            }
                        }],
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                stepSize: 1,
                                precision: 0
                            }
                        }]
                    }
                }
            });
        },

        initsituacaoChartAlmoxarifado() {
            const ctx = document.getElementById('situacaoChartAlmoxarifado');
            if (!ctx) return;

            if (this.situacaoChartAlmoxarifado) {
                this.situacaoChartAlmoxarifado.destroy();
            }

            const situacaoData = this.dashboardData.quantidadePorSitucao || {};
            const labels = Object.keys(situacaoData);
            const values = [];


            const colorMap = {
                'Inventariando': {
                    background: 'rgba(75, 192, 192, 0.6)',
                    border: 'rgba(75, 192, 192, 1)'
                },
                'Livre': {
                    background: 'rgba(55, 140, 172, 0.6)',
                    border: 'rgba(55, 140, 172, 1)'
                },
                'Bloqueado': {
                    background: 'rgba(122, 122, 132, 0.6)',
                    border: 'rgba(122, 122, 132, 1)'
                },
                'Desbloqueado': {
                    background: 'rgba(150, 111, 132, 0.6)',
                    border: 'rgba(150, 111, 132, 1)'
                },
                'Visivel': {
                    background: 'rgba(182, 122, 62, 0.6)',
                    border: 'rgba(182, 122, 62, 1)'
                },
                'Invisivel': {
                    background: 'rgba(150, 100, 72, 0.6)',
                    border: 'rgba(150, 100, 72, 1)'
                }



            };

            const backgroundColors = [];
            const borderColors = [];

            labels.forEach(label => {
                values.push(situacaoData[label]);

                if (colorMap[label]) {
                    backgroundColors.push(colorMap[label].background);
                    borderColors.push(colorMap[label].border);
                } else {
                    backgroundColors.push(this.chartColors[backgroundColors.length % this.chartColors.length]);
                    borderColors.push(this.chartBorderColors[borderColors.length % this.chartBorderColors.length]);
                }
            });



            const total = values.reduce((a, b) => (a || 0) + (b || 0), 0);
            const centerTextPlugin = {
                beforeDraw: (chart) => {
                    const { width, height, ctx } = chart.chart;
                    ctx.save();
                    const fontSize = (height / 180).toFixed(2);
                    ctx.font = `${fontSize}em Helvetica Neue, Arial, sans-serif`;
                    ctx.textBaseline = 'middle';
                    ctx.fillStyle = '#6c757d';
                    const text = total || 0;
                    const textX = Math.round((width - ctx.measureText(text).width) / 2);
                    const textY = height / 2;
                    ctx.fillText(text, textX, textY);
                    ctx.restore();
                }
            };

            this.situacaoChartAlmoxarifado = new Chart(ctx, {
                type: 'doughnut',
                data: {
                    labels: labels,
                    datasets: [{
                        data: values,
                        backgroundColor: backgroundColors,
                        borderColor: borderColors,
                        borderWidth: 1
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    cutoutPercentage: 70,
                    legend: { display: false },
                    tooltips: {
                        callbacks: {
                            label: (item, data) => {
                                const v = data.datasets[0].data[item.index] || 0;
                                const pct = total ? ((v / total) * 100).toFixed(1) : '0.0';
                                return `${data.labels[item.index]}: ${v} (${pct}%)`;
                            }
                        }
                    }
                },
                plugins: [centerTextPlugin]
            });
        },
        truncateLabel(value) {
            if (!value) return '';
            const max = 16;
            return String(value).length > max ? String(value).slice(0, max - 1) + '…' : value;
        },
        formatCurrency(value) {
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value || 0);
        }
    }
};
</script>

<style scoped lang="scss">
.almoxarifado-dashboard {
    .page-title-header {
        margin-bottom: 1.5rem;

        .page-header {
            padding-bottom: 0;
            border-bottom: none;
            margin-bottom: 1.5rem;

            .page-title {
                font-weight: 500;
                font-size: 1.5rem;
                margin-bottom: 0.5rem;
            }

            .quick-links {
                list-style: none;
                padding-left: 0;
                display: flex;
                margin-bottom: 0;

                li {
                    display: inline-block;
                    margin-right: 1rem;

                    a {
                        color: #6c757d;
                        font-weight: 500;

                        &:hover {
                            color: #007bff;
                            text-decoration: none;
                        }
                    }
                }
            }
        }
    }

    .card {
        border-radius: 4px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
        margin-bottom: 1.5rem;

        .card-body {
            padding: 1.5rem;
        }

        .col-md-8.grid-margin.stretch-card .card-body,
        .col-md-4.grid-margin.stretch-card .card-body {
            min-height: 456px;
        }

        .card-title {
            font-weight: 500;
            margin-bottom: 1rem;
        }
    }

    .chart-container {
        position: relative;
        margin: auto;
    }

    .chartjs-legend-almoxarifado {
        ul {
            list-style: none;
            padding-left: 0;
            display: flex;
            flex-wrap: wrap;

            li {
                display: flex;
                align-items: center;
                margin-right: 1rem;
                margin-bottom: 0.5rem;

                span {
                    display: inline-block;
                    width: 12px;
                    height: 12px;
                    margin-right: 0.5rem;
                    border-radius: 50%;
                }
            }
        }
    }

    .wrapper {
        min-height: auto !important;
        height: auto !important;
        position: relative;

        .font-weight-semibold {
            font-weight: 600;
        }

        .text-primary {
            color: #007bff !important;
        }

        .text-muted {
            color: #6c757d !important;
        }
    }

    .btn-outline-primary {
        color: #007bff;
        border-color: #007bff;

        &:hover {
            background-color: #007bff;
            color: #fff;
        }
    }
}

@media (max-width: 991px) {
    .almoxarifado-dashboard .row>[class^="col-"] {
        margin-bottom: 1.2rem;
    }

    .almoxarifado-dashboard .d-flex {
        flex-direction: column !important;
        align-items: stretch !important;
    }


    .almoxarifado-dashboard .chart-container,
    .almoxarifado-dashboard .chart-container canvas {
        width: 100% !important;
        min-width: 0 !important;
        max-width: 100% !important;
        margin-left: 0 !important;
        margin-right: 0 !important;
    }

    .almoxarifado-dashboard .chartjs-legend-almoxarifado ul {
        flex-direction: column;
        align-items: flex-start;
    }

    .almoxarifado-dashboard .chartjs-legend-almoxarifado li {
        margin-right: 0;
        margin-bottom: 0.6rem;
    }
}

.almoxarifado-dashboard #situacao-legend-almoxarifado,
.almoxarifado-dashboard .chartjs-legend-almoxarifado {
    width: 100%;
    overflow-x: auto;
}

.almoxarifado-dashboard .chart-container {
    max-width: 100%;
    min-width: 0;
    /* Não use width/height fixo inline em mobile */
}

.almoxarifado-dashboard .d-flex {
    flex-wrap: nowrap;
    align-items: center;

}

.almoxarifado-dashboard .wrapper {
    min-width: 0 !important;
    width: 100%;
    max-width: 100%;
    overflow: hidden;

}


.almoxarifado-dashboard .wrapper h3,
.almoxarifado-dashboard .wrapper p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
    display: inline-block;
    vertical-align: top;
    cursor: pointer;
    transition: background 0.2s, box-shadow 0.2s;
    position: relative;
}

.almoxarifado-dashboard .wrapper h3:hover,
.almoxarifado-dashboard .wrapper p:hover {
    white-space: normal;
    overflow: visible;
    z-index: 10;
}


.almoxarifado-dashboard .chart-container,
.almoxarifado-dashboard .chart-container canvas {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
}
</style>
